export default {
  home: {
    lang: 'En',
    lang_cn: 'Chinese',
    lang_en: 'English',
    form_title:'iCAUR V23 Preview Register now to receive the upcoming promotions and activities.',
    submit:'Submit',
    mandatory:'Mandatory',
    yes:"Yes",
    no:"No",
    lastName:'Last name',
    firstName:'First name',
    enterLastName:'Please enter your last name',
    enterFirstName:'Please enter your  First name',
    emailAddress:'Email address',
    enterEmail:'Please enter your email',
    rightEmail:'Please enter the correct email address!',
    mobileNumber:'Mobile number',
    enterPhone:'Please enter your phone number',
    rightPhone:'Please enter the correct phone number!',
    privacyPolicy:"I/We agree with the use of my/our personal data by KLM,its affiliates, subsidiaries and associated companies for direct marketing purposes in accordance with the Personal Information Collection Statement and the Privacy Policy Statement.",
    appellation:'appellation',
    selectAppellation:'Please select a title',
    corporateClient:'Corporate client',
    selectLanguage:'Select language',
    pleaseSelectLanguage:'Please select language',
    InformationSubmitted:'Information submitted successfully!',
    pleaseWriteName:'Please write down the company name',
    pleaseWriteName_:'If so, please write down the company name',
    agree_:'I/We have read and agree to the',
    statement_:'Personallnformation Collection Statement.',
    policy_:'Privacy Policy Statement',
    and:'and',
    corporateClient_:'Please select a corporate customer',
    _policy:'Please select the privacy policy',
  },
};

